import labelsConfig from '@/config/label-data/labels.config';

class LabelService {
	constructor() {
		this.labels = new Map();
		this.loadLabels();
	}

	loadLabels() {
		labelsConfig.forEach(tenantConfig => {
			this.labels.set(tenantConfig.tenantId, tenantConfig.labels);
		});
	}

	getLabel(tenantId, labelKey, defaultValue = '') {
		const tenantLabels = this.labels.get(tenantId);
		if (!tenantLabels) {
			return defaultValue;
		}
		return tenantLabels[labelKey] || defaultValue;
	}

	getLabels(tenantId) {
		return this.labels.get(tenantId) || {};
	}

	hasLabels(tenantId) {
		return this.labels.has(tenantId);
	}

	formatLabel(label, replacements = {}) {
		let formattedLabel = label;
		Object.keys(replacements).forEach(key => {
			const placeholder = `{${key}}`;
			formattedLabel = formattedLabel.replace(new RegExp(placeholder, 'g'), replacements[key]);
		});
		return formattedLabel;
	}
}

export const labelService = new LabelService();

export const LabelsPlugin = {
	install(Vue) {
		Vue.prototype.$labels = labelService;
		Vue.prototype.$getLabel = (labelKey, defaultValue = '') => {
			const tenantId = Vue.prototype.$route?.query?.tid || import.meta.env.VITE_DEFAULT_TENANT_ID;
			return labelService.getLabel(tenantId, labelKey, defaultValue);
		};
	},
};
